import { render } from "./App.vue?vue&type=template&id=65ea88f4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=65ea88f4&lang=scss"

import exportComponent from "D:\\___________A_Projects VUE JS 3\\cv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__